import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

const CategoryDetail = () => {
  const { categoryId } = useParams();
  const [selectedDisplay, setSelectedDisplay] = useState("8");

  const categoryInfo = {
    name: "Electronique",
    productCount: 100,
    stock: 812,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    createdAt: "14 January 2024, 10:00"
  };

  const products = [
    {
      id: 1,
      name: "Earphone G1",
      sku: "JL293819113",
      image: "/images/ecouteur.png",
      price: 55000,
      stock: 134,
      status: "Publié",
      statusColor: "bg-green-100 text-green-800"
    },
    {
      id: 2,
      name: "TWS Earphone",
      sku: "JL293819113",
      image: "/images/ecouteur.png",
      price: 14000,
      stock: 29,
      status: "Publié",
      statusColor: "bg-green-100 text-green-800"
    },
    {
      id: 3,
      name: "Mouse Logic G",
      sku: "JL293819113",
      image: "/images/app.png",
      price: 55000,
      stock: 240,
      status: "Non publié",
      statusColor: "bg-gray-100 text-gray-800"
    },
    {
      id: 4,
      name: "Berry Samrtwat",
      sku: "JL293819113",
      image: "/images/app.png",
      price: 14000,
      stock: 0,
      status: "Rupture de stock",
      statusColor: "bg-red-100 text-red-800"
    },
    {
      id: 5,
      name: "Mouse Logic G",
      sku: "JL293819113",
      image: "/images/app.png",
      price: 14000,
      stock: 56,
      status: "Non publié",
      statusColor: "bg-gray-100 text-gray-800"
    },
    {
      id: 6,
      name: "TWS Earphone",
      sku: "JL293819113",
      image: "/images/ecouteur.png",
      price: 55000,
      stock: 91,
      status: "Publié",
      statusColor: "bg-green-100 text-green-800"
    }
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Detail de la Catégorie
            <div className="w-16 h-0.5 bg-orange-500 mt-2"></div>
          </h1>
          <div className="text-sm text-gray-600">
            <Link to="/dashboard" className="text-orange-500 hover:text-orange-600">
              Tableau de bord
            </Link>
            <span className="mx-2">{'>'}</span>
            <Link to="/dashboard/categories" className="text-orange-500 hover:text-orange-600">
              Catégories de produits
            </Link>
            <span className="mx-2">{'>'}</span>
            <span>Detail de la Catégorie</span>
          </div>
        </div>
        
        {/* Action Buttons */}
        <div className="flex items-center gap-4">
          {/* Delete Button */}
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>

          {/* Edit Button */}
          <button className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Modifier
          </button>
        </div>
      </div>

      {/* Main Content - Two Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left Column - Category Overview */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-6">{categoryInfo.name}</h2>
            
            <div className="space-y-6">
              {/* Product Count */}
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Nombre de produit</p>
                  <p className="text-gray-900 font-medium">{categoryInfo.productCount}</p>
                </div>
              </div>

              {/* Stock */}
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">En stock</p>
                  <p className="text-gray-900 font-medium">{categoryInfo.stock}</p>
                </div>
              </div>

              {/* Description */}
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Description</p>
                  <p className="text-gray-900">{categoryInfo.description}</p>
                </div>
              </div>

              {/* Creation Date */}
              <div className="flex items-center gap-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <div>
                  <p className="text-sm text-gray-500">Date de création</p>
                  <p className="text-gray-900">{categoryInfo.createdAt}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Products List */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            {/* Search and Filter Bar */}
            <div className="flex items-center gap-4 mb-6">
              {/* Search Bar */}
              <div className="relative flex-1 max-w-md">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Recherche..."
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
              </div>

              {/* Filter Button */}
              <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                <span className="text-gray-700">Filtre</span>
              </button>

              {/* Display Options */}
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <span className="text-gray-700">Affichage</span>
                <select
                  value={selectedDisplay}
                  onChange={(e) => setSelectedDisplay(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="8">8</option>
                  <option value="16">16</option>
                  <option value="24">24</option>
                  <option value="32">32</option>
                </select>
              </div>
            </div>

            {/* Products Table */}
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left">
                      <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">PRODUIT</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">PRICE</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">STOCK</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">STATUS</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {products.map((product) => (
                    <tr key={product.id} className="hover:bg-gray-50">
                      <td className="px-4 py-4">
                        <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-3">
                          <img src={product.image} alt={product.name} className="w-10 h-10 rounded-lg object-cover" />
                          <div>
                            <p className="text-sm font-medium text-gray-900">{product.name}</p>
                            <p className="text-xs text-gray-500">SKU: {product.sku}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <p className="text-sm text-gray-900">{product.price.toLocaleString()} FCFA</p>
                      </td>
                      <td className="px-4 py-4">
                        <p className="text-sm text-gray-900">{product.stock}</p>
                      </td>
                      <td className="px-4 py-4">
                        <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${product.statusColor}`}>
                          {product.status}
                        </span>
                      </td>
                      <td className="px-4 py-4">
                        <button className="text-gray-400 hover:text-gray-600">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryDetail;
